module.exports = __webpack_public_path__ + "img/comentarios.e64e2410.svg";